/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `personal_finance` - Życie
 * * `business_finance` - Firma
 * * `iot_gec` - IoT/GEC
 */
export type QuizContentModuleEnum = typeof QuizContentModuleEnum[keyof typeof QuizContentModuleEnum];


export const QuizContentModuleEnum = {
  personal_finance: 'personal_finance',
  business_finance: 'business_finance',
  iot_gec: 'iot_gec',
} as const;
